import { Task } from '@griply/types';

import { isTimeslotAction } from './is-timeslot-action';
import { normalizeForSearch } from './normalize-for-search';

export const filterTasksBySearchText = (
  tasks: Task[],
  searchText: string,
): Task[] => {
  if (!searchText) {
    return [];
  }
  const normalizedSearchText = normalizeForSearch(searchText.trim());

  return tasks
    .filter(
      ({ name, description, action, parentIds }) =>
        !parentIds?.length &&
        !isTimeslotAction(action?.type) &&
        (normalizeForSearch(name).includes(normalizedSearchText) ||
          (!!description &&
            normalizeForSearch(description).includes(normalizedSearchText))),
    )
    .sort(
      (taskA, taskB) =>
        (taskA.completedAt ? 1 : 0) - (taskB.completedAt ? 1 : 0) ||
        new Date(taskA.createdAt).getTime() -
          new Date(taskB.createdAt).getTime(),
    );
};
